import { VueRegistration } from '@abaco/web-common/src/app';

const globals: VueRegistration = {
    // tiles
    "damage-claim-list-tile": () => import("./components/tiles/DamageClaimListTile.vue"),
    "damage-claim-stepper-tile": () => import("./components/tiles/DamageClaimStepperTile.vue"),
    // steps
    "damage-claim-pcert-selection-step": () => import("./components/steps/DamageClaimPcertSelectionStep.vue"),
    "damage-claim-plot-selection-step": () => import("./components/steps/DamageClaimPlotSelectionStep.vue"),
    "certigraf-plot-map-step": () => import("./components/steps/DamageClaimPlotMapStep.vue"),
    "certigraf-plot-list-step": () => import("./components/steps/DamageClaimPlotListStep.vue"),
    "damage-claim-product-step": () => import("./components/steps/DamageClaimProductStep.vue"),
    "damage-claim-details-step": () => import("./components/steps/DamageClaimDetailsStep.vue"),
    "damage-claim-receiver-step": () => import("./components/steps/DamageClaimReceiverStep.vue"),
    "damage-claim-user-step": () => import("./components/steps/DamageClaimUserStep.vue"),
    // dialog
    "dialog-component": () => import("./components/utils/DialogComponent.vue"),
};

export default globals;
